import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { ShoppingCartListComponent } from '../../components/shopping-cart-list/shopping-cart-list.component';

@Component({
  selector: 'cv-footer-subtotal-rendered',
  template: `
          <span style="color: #353A40;margin-bottom:40px;">
            <span>{{this.shoppingCartListComponent.getLocalizationString("Total_Price", "Total Price")}}: </span>
            <!-- <svg class="icon-24 fill-bananaSlug" style="margin: 0 4px;"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg> -->
            <span style="font-weight: bold;margin-left: 5px;">{{this.shoppingCartListComponent.cvNumberLocalize.transform(this.shoppingCartListComponent.getTotal())}}</span>
            <span style="margin-left: 4px;font-weight: bold;">{{this.shoppingCartListComponent.getLocalizationString("Coins", "Coins")}}</span>
          </span>
  `,
  styleUrls: ['./footer-subtotal-rendered.component.scss']
})
export class FooterSubtotalRenderedComponent implements ICellRendererAngularComp {

  constructor(public shoppingCartListComponent: ShoppingCartListComponent) { }
  refresh(params: ICellRendererParams): boolean {
    return true;
  }
  agInit(params: ICellRendererParams): void {

  }
}
